import React from 'react';
import { Flex } from 'antd';
import styled from 'styled-components';

import { ProductActionList, ProductProps } from '../service/products.interface';
import { useTheme } from '../../../../../hooks/useTheme';
import { useManageProducts } from '../hooks/useManageProducts';
import { PRODUCT_ACTIONS, ACTIONS } from '../utils/products';

export const ProductActions = ({
    item,
    isMultipleActionsAvailable,
}: {
    item: ProductProps;
    isMultipleActionsAvailable: boolean;
}) => {
    const { colorBorder, colorIcon, colorIconHover } = useTheme();
    const {
        manageProduct,
        changeProductStatus,
        deleteProduct,
        copyDirectLink,
    } = useManageProducts();

    const handleAction = (type: ProductActionList, item: ProductProps) => {
        if (isMultipleActionsAvailable) {
            return;
        } else {
            switch (type) {
                case PRODUCT_ACTIONS.archive:
                    return changeProductStatus(item.id, item.status);
                case PRODUCT_ACTIONS.delete:
                    return deleteProduct(item.id);
                case PRODUCT_ACTIONS.edit:
                    return manageProduct('edit', item.id);
                case PRODUCT_ACTIONS.copyDirectLink:
                    return copyDirectLink(item.shop_id, item.id);
            }
        }
    };

    return (
        <Flex gap={16}>
            {ACTIONS.sort((a, b) => a.position - b.position).map(
                (action, index) => (
                    <StyledIcon
                        $colorDefault={
                            isMultipleActionsAvailable ? colorBorder : colorIcon
                        }
                        $colorActive={
                            isMultipleActionsAvailable
                                ? colorBorder
                                : colorIconHover
                        }
                        $isAvailable={!isMultipleActionsAvailable}
                        key={index}
                        onClick={() => handleAction(action.type, item)}
                    >
                        {action.component}
                    </StyledIcon>
                )
            )}
        </Flex>
    );
};

const StyledIcon = styled.div<{
    $colorDefault: string;
    $colorActive: string;
    $isAvailable: boolean;
}>`
    font-size: 24px;
    cursor: ${props => (props.$isAvailable ? 'pointer' : 'not-allowed')};
    color: ${props => props.$colorDefault};
    &:hover {
        color: ${props => props.$colorActive};
    }
`;
